import React from 'react';
import { motion } from 'framer-motion';
import './Contact.css';

const Contact = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }
    }
  };

  return (
    <section className="contact-v2" id="contact">
      <div className="contact-glow"></div>

      <div className="contact-container">
        <div className="contact-header">
          <motion.span className="accent-tag" initial="hidden" whileInView="visible" variants={itemVariants}>
            Get In Touch
          </motion.span>
          <motion.h2 initial="hidden" whileInView="visible" variants={itemVariants}>
            Let's <span className="highlight">Grow Your Business</span>
          </motion.h2>
          <motion.p initial="hidden" whileInView="visible" variants={itemVariants}>
            Drop us a message anytime and we'll get back to you as soon as possible.
          </motion.p>
        </div>

        <div className="contact-box">
          <motion.div
            className="contact-info-panel"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <div className="info-item card">
              <div className="info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
              </div>
              <div className="info-text">
                <h4>Point of Contact</h4>
                <p>
                  <a
                    href="https://www.linkedin.com/in/vinushnalakkakula"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}
                  >
                    Vinushna Lakkakula <i className="fab fa-linkedin" style={{ color: '#0077b5', fontSize: '1.2em' }}></i>
                  </a>
                </p>
              </div>
            </div>

            <div className="info-item card">
              <div className="info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-phone"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.81 12.81 0 0 0 .62 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.62A2 2 0 0 1 22 16.92z"></path></svg>
              </div>
              <div className="info-text">
                <h4>Call Us</h4>
                <p>+91 63047 65654</p>
              </div>
            </div>

            <div className="info-item card">
              <div className="info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
              </div>
              <div className="info-text">
                <h4>Email Us</h4>
                <p>vinushna.lakkakula@cabptoidsolutions.com</p>
              </div>
            </div>

            <div className="info-item card">
              <div className="info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </div>
              <div className="info-text">
                <h4>Find Us</h4>
                <p>
                  2nd Floor, Aikya Vihar, Kavuri Hills,
                  <br />
                  Hyderabad, Telangana – 500033
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="contact-form-panel"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <form className="premium-form">
              <div className="form-group">
                <input type="text" placeholder="Your Name" required />
                <span className="input-focus"></span>
              </div>
              <div className="form-group">
                <input type="email" placeholder="Your Email" required />
                <span className="input-focus"></span>
              </div>
              <div className="form-group">
                <input type="text" placeholder="Company Name" />
                <span className="input-focus"></span>
              </div>

              <div className="form-group">
                <textarea placeholder="Your Message" rows="5" required></textarea>
                <span className="input-focus"></span>
              </div>

              <button type="submit" className="submit-premium">
                Send Message
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;